module.exports = __webpack_public_path__ + "img/TEEP@3x.90fe00ed.png";